import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { PRIORITY } from "../lib/format";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { DateInput } from "./DateInput";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";

export function EditDemandDialog({ r, open, onOpenChange, onDone }) {
  const [f, setF] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF({ title: r.title, description: r.description || "", priority: r.priority || "normal", due: r.promised_due_date || "" }); }, [open]); // eslint-disable-line
  const go = async () => {
    setBusy(true);
    try { await api.patch(`/requests/${r.id}`, { title: f.title, description: f.description, priority: f.priority, promised_due_date: f.due || undefined }); toast.success("Demanda atualizada"); onOpenChange(false); onDone?.(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="dp-edit-dialog">
        <DialogHeader><DialogTitle>Editar demanda</DialogTitle><DialogDescription>#{r.protocol}</DialogDescription></DialogHeader>
        <div className="space-y-3">
          <div><Label>Título</Label><Input className="mt-1.5" value={f.title || ""} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="dp-edit-title" /></div>
          <div><Label>Descrição</Label><Textarea rows={3} className="mt-1.5" value={f.description || ""} onChange={(e) => setF({ ...f, description: e.target.value })} data-testid="dp-edit-description" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Prioridade</Label><Select value={f.priority} onValueChange={(v) => setF({ ...f, priority: v })}><SelectTrigger className="mt-1.5" data-testid="dp-edit-priority"><SelectValue /></SelectTrigger><SelectContent>{Object.entries(PRIORITY).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent></Select></div>
            <div><Label>Prazo de retorno</Label><DateInput testid="dp-edit-due" className="mt-1.5" value={f.due || ""} onChange={(v) => setF({ ...f, due: v })} /></div>
          </div>
        </div>
        <DialogFooter><Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button><Button disabled={busy || !(f.title || "").trim()} onClick={go} data-testid="dp-edit-save">Salvar</Button></DialogFooter>
      </DialogContent>
    </Dialog>);
}

export function DeleteDemandDialog({ r, open, onOpenChange, onDone }) {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await api.delete(`/requests/${r.id}`); toast.success(`Demanda #${r.protocol} excluída`); onOpenChange(false); onDone?.(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="dp-delete-dialog">
        <DialogHeader><DialogTitle>Excluir demanda definitivamente?</DialogTitle><DialogDescription>#{r.protocol} · {r.title}</DialogDescription></DialogHeader>
        <p className="text-sm text-slate-600">A demanda, seus anexos e mensagens serão apagados do Backoffice e do Portal Empresa. Esta ação não pode ser desfeita.</p>
        <DialogFooter><Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button><Button className="bg-rose-600 hover:bg-rose-700" disabled={busy} onClick={go} data-testid="dp-delete-confirm"><Trash2 className="h-4 w-4 mr-1.5" />Excluir definitivamente</Button></DialogFooter>
      </DialogContent>
    </Dialog>);
}
